'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _footerCell = require('./footer-cell');

var _footerCell2 = _interopRequireDefault(_footerCell);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint react/require-default-props: 0 */


var Footer = function Footer(props) {
  var data = props.data,
      className = props.className,
      columns = props.columns;
  return _react2.default.createElement('tfoot', null, _react2.default.createElement('tr', {
    className: className
  }, columns.map(function (column, i) {
    if (column.footer === undefined || column.footer === null || column.hidden) {
      return false;
    }

    var columnData = _utils2.default.pluck(data, column.dataField);

    return _react2.default.createElement(_footerCell2.default, {
      index: i,
      key: column.dataField,
      column: column,
      columnData: columnData
    });
  })));
};

Footer.propTypes = {
  data: _propTypes2.default.array,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array
};
exports.default = Footer;